<template>

    <form class="form" @submit.prevent="signup" autocomplete="on">
        <v-input placeholder="Your Email Address" type="email" autocomplete="email" :model="email" @input="email = $event" :invalid="invalid" borderless />
        <v-button size="md" btn-style="primary" :loading="loading" @click.native="signup">Start 14-Day Free Trial</v-button>
    </form>

</template>

<style scoped lang="scss">

    .form {
        background: #fff;
        border: 2px solid $color-primary;
        border-radius: 6px;
        display: grid;
        gap: 10px;
        grid-auto-flow: column;
        grid-template-columns: 1fr 220px;
        padding: 10px;
        position: relative;
        z-index: 100;
        input {
            font-size: 14px;
            font-weight: 600;
        }
        @media (max-width: map-get($grid-breakpoints, 'lg')) {
            grid-auto-flow: row;
            grid-template-columns: auto;
        }
    }

</style>

<script>

import { Base64 } from 'js-base64';

export default {

    data() {
        return {
            appUrl: process.env.VUE_APP_APP_URL,
            email: '',
            invalid: false,
            loading: false,
        }
    },

    methods: {

        signup() {
            this.loading = true;
            this.invalid = false;
            if (!this.email) {
                this.loading = false;
                this.invalid = true;
                return;
            };
            // Redirect to signup.
            let email = Base64.encode(this.email);
            let url = `${this.appUrl}/signup?email=${email}`;
            window.location.href = url;
        },

    },

}

</script>